var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.998 2.996V11.7M13 8.698l-3.002 3M6.996 8.698l3.001 3M13 4.997h1a3.001 3.001 0 0 1 3.002 3.001v6.003A3.001 3.001 0 0 1 14 17.002H5.997a3.001 3.001 0 0 1-3-3.001V7.998a3.001 3.001 0 0 1 3-3h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17 8.999h1A3.001 3.001 0 0 1 21.003 12v6.003a3.001 3.001 0 0 1-3.001 3H9.997a3.001 3.001 0 0 1-3-3v-1"
  })));
};
export { SvgDownload as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMTkyN2MzNTNhOGQxMWY5ZTcxOGZlMmZmZWZjZWYzNjcuc3ZnIjs=";